import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

class InputCVV extends Component {

    render(){
        return (
            'Teste 123456'
        )
    }

}


export default InputCVV